import React, { useState } from "react";
import Swal from "sweetalert2";

function RequestForm({master, onSaved}) {

    const [form, setForm] = useState({
        agent: '',
        processor: '',
        identification: '',
        identification_type: '',
        specific_identification_type: '',
        number: '',
        reason: '',
        specific_reason: '',
        amc_representative: '',
    });

    // Estados para errores
    const [errors, setErrors] = useState({});

    // Manejador general para cambios
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
        // Limpiar error al escribir
        setErrors({ ...errors, [name]: '' });
    };

    const handleSave = () => {
        const newErrors = {};

        // Validar solo los campos obligatorios (sin los "specific")
        if (!form.agent.trim()) newErrors.agent = 'Campo requerido';
        if (!form.processor.trim()) newErrors.processor = 'Campo requerido';
        if (!form.identification.trim()) newErrors.identification = 'Campo requerido';
        if (!form.identification_type.trim()) newErrors.identification_type = 'Campo requerido';
        if (!form.number.trim()) newErrors.number = 'Campo requerido';
        if (!form.reason.trim()) newErrors.reason = 'Campo requerido';
        if (!form.amc_representative.trim()) newErrors.amc_representative = 'Campo requerido';

        // Validaciones adicionales SOLO si se eligió "Otro"
        if (form.identification_type === 'Otro' && !form.specific_identification_type.trim()) {
            newErrors.specific_identification_type = 'Campo requerido';
        }

        if (form.reason === 'Otro' && !form.specific_reason.trim()) {
            newErrors.specific_reason = 'Campo requerido';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            const dataToSend = {
                agent: form.agent,
                processor: form.processor,
                identification: form.identification,
                identification_type: form.identification_type,
                specific_identification_type: form.identification_type === 'Otro' ? form.specific_identification_type : null,
                number: form.number,
                reason: form.reason,
                specific_reason: form.reason === 'Otro' ? form.specific_reason : null,
                amc_representative: form.amc_representative,
            };

            console.log("Datos preparados para backend:", dataToSend);

            Swal.fire({
                title: "Desistimiento registrado con éxito",
                icon: "success",
                customClass: {
                    confirmButton: 'btn-ok',
                    title: 'alert-title',
                    popup: 'alert-bg'
                },
                confirmButtonText: "Cerrar",
            });
            onSaved(); // Le avisa al padre
        }
    }

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <label for="agent" class="amc-label">Agencia *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="agent"
                            value={form.agent}
                            onChange={handleChange}
                        />
                        {errors.agent && <small className="text-danger">{errors.agent}</small>}
                    </div>
                    <div className="col-6">
                        <label for="processor" class="amc-label">Tramitador *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="processor"
                            value={form.processor}
                            onChange={handleChange}
                        />
                        {errors.processor && <small className="text-danger">{errors.processor}</small>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <label for="identification" class="amc-label">ID *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="identification"
                            value={form.identification}
                            onChange={handleChange}
                        />
                        {errors.identification && <small className="text-danger">{errors.identification}</small>}
                    </div>
                    <div className="col-6">
                        <label for="identification_type" class="amc-label">Tipo *</label>
                        <select name="identification_type" class="form-select" value={form.identification_type} onChange={handleChange} >
                            <option value="SAT">SAT</option>
                            <option value="INE">INE</option>
                            <option value="Pasaporte">Pasaporte</option>
                            <option value="Otro">Otro</option>
                        </select>
                        {errors.identification_type && <small className="text-danger">{errors.identification_type}</small>}
                    </div>
                    {form.identification_type === 'Otro' && (
                        <div className="col-6">
                            <label className="amc-label">Especificar tipo *</label>
                            <input 
                                type="text"
                                className="form-control"
                                name="specific_identification_type"
                                value={form.specific_identification_type}
                                onChange={handleChange}
                            />
                            {errors.specific_identification_type && <small className="text-danger">{errors.specific_identification_type}</small>}
                        </div>
                    )}
                    <div className="col-6">
                        <label for="number" class="amc-label">Número *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="number"
                            value={form.number}
                            onChange={handleChange}
                        />
                        {errors.number && <small className="text-danger">{errors.number}</small>}
                    </div>
                    <div className="col-6">
                        <label for="reason" class="amc-label">Motivo del desistimiento *</label>
                        <select name="reason" class="form-select" value={form.reason} onChange={handleChange} >
                            <option value="Daño">Daño</option>
                            <option value="Rezago">Rezago</option>
                            <option value="Dimensiones">Dimensiones</option>
                            <option value="Naturaleza del embarque">Naturaleza del embarque</option>
                            <option value="Itinerario">Itinerario</option>
                            <option value="Otro">Otro</option>
                        </select>
                        {errors.reason && <small className="text-danger">{errors.reason}</small>}
                    </div>
                    {form.reason === 'Otro' && (
                        <div className="col-6">
                            <label className="amc-label">Especificar motivo *</label>
                            <input 
                                type="text"
                                className="form-control"
                                name="specific_reason"
                                value={form.specific_reason}
                                onChange={handleChange}
                            />
                            {errors.specific_reason && <small className="text-danger">{errors.specific_reason}</small>}
                        </div>
                    )}
                    <div className="col-6">
                        <label for="amc_representative" class="amc-label">Representante AM Cargo *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="amc_representative"
                            value={form.amc_representative}
                            onChange={handleChange}
                        />
                        {errors.amc_representative && <small className="text-danger">{errors.amc_representative}</small>}
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end gap-3">
                        <button className='btnn' onClick={handleSave} >Guardar</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RequestForm;